export default "__VITE_ASSET__CcLdigPP__"